import {
  reloadRegistryTabsAndCounters,
  useReloadRegistry,
} from '../../../../hooks'
import { UserProfileTabId } from '../../User.constants'

/**
 * Bundles the reload registries of every user-profile tab that nested
 * components register into (see {@link useReloadRegistry}) and exposes
 * `handleReloadTabs(tabIds)` — the single way for out-of-tab actions to
 * refresh tabs, so the tab counters are refreshed exactly once (the user
 * counters loader takes the tab ids — see `UserProfileTabs`).
 */
export function useUserProfileReloadRegistries() {
  const buildingsTab = useReloadRegistry()
  const categoriesTab = useReloadRegistry()
  const contractsTab = useReloadRegistry()
  const documentsTab = useReloadRegistry()
  const emailsTab = useReloadRegistry()
  const requestsTab = useReloadRegistry()

  const {
    handleReload: handleReloadTabCounters,
    registerReload: registerTabCountersReload,
  } = useReloadRegistry()

  const registriesByTabId = {
    [UserProfileTabId.Buildings]: buildingsTab,
    [UserProfileTabId.Categories]: categoriesTab,
    [UserProfileTabId.Contracts]: contractsTab,
    [UserProfileTabId.Documents]: documentsTab,
    [UserProfileTabId.Emails]: emailsTab,
    [UserProfileTabId.Requests]: requestsTab,
  }

  async function handleReloadTabs(tabIds) {
    return reloadRegistryTabsAndCounters({
      registriesByTabId,
      reloadCounters: handleReloadTabCounters,
      tabIds,
    })
  }

  return {
    handleReloadTabs,
    registerBuildingsTabReload: buildingsTab.registerReload,
    registerCategoriesTabReload: categoriesTab.registerReload,
    registerContractsTabReload: contractsTab.registerReload,
    registerDocumentsTabReload: documentsTab.registerReload,
    registerEmailsTabReload: emailsTab.registerReload,
    registerRequestsTabReload: requestsTab.registerReload,
    registerTabCountersReload,
  }
}
